import FileSystem from "./filesystem.js"


/**
 * The FileSystem class.
 */
export default FileSystem
